@use '@/sass/variables';
.step-container {
  min-height: 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .step-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .add-task-input-field {
    margin-bottom: 0;
    input {
      // <InputWithUnits /> `classes` doesn't assign to input
      margin-bottom: 0;
    }
    &.add-task-recurring-field {
      width: 170px;
    }
  }
  .schedule-daylist-container {
    column-count: 2;
    column-gap: 0px;
    width: 275px;
    .schedule-daylist-item {
      break-inside: avoid;
    }
  }
}

.controlChip {
  color: variables.$dark-blue;
  padding: 3px;
  background-color: variables.$washed-blue;
  border: 1px solid variables.$dark-blue;
  border-radius: 3px;
}
